import { Component, Input } from '@angular/core'
import { TableColumn } from './table-column'
import { VerticalBreakpoint } from './table.component'

@Component({
  selector: 'ftr-table-column-header',
  templateUrl: './table-column-header.component.html',
  styleUrls: ['./table-column-header.component.css'],
})
export class TableColumnHeaderComponent<T> {
  @Input()
  columns: TableColumn<T>[]

  @Input()
  verticalBreakpoint: VerticalBreakpoint = 'small'
}
